<template>
  <div class="Pon-Button" :style="{ backgroundImage: `url(${backgroundImage})`}">
    <img class="Pon-Button__nft" :src="require('@/Groups/Pon/private/media/images/icon-pon-x3-size.png')" alt="NFT" />
    <LoaderCircle class="Pon-Button__loader" :color="'white'" :size="18" v-if="isLoadingUserData || isLoading" />
    <LockIcon class="Pon-Button__lock" v-else-if="!hasPaidAccount" />
    <span class="Pon-Button__value" v-else>
      {{ data?.nft_data?.floor_price_eth?.toFixed(2) }}
    </span>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { onMounted, watch, computed } from 'vue';
  import { useUserAuth } from '@/Groups/Pon/private/imports/userStoreData';
  import { LoaderCircle } from '@/Groups/Pon/private/imports/externalTemplates';
  import LockIcon from '@/Groups/Pon/private/svg/LockIcon.vue';
  //--------------------------------
  const store = useStore();
  const { hasPaidAccount, isLoadingUserData, hasLegendAccess } = useUserAuth();
  //--------------------------------
  onMounted(async () => {
    if (!hasPaidAccount.value) return;
    store.dispatch('Pon/fetchPonData');
  });
  //--------------------------------
  // Пути к фонам
  const BG_LEGEND = require('@/Shared/images/backgrounds/bg_legend_height.png');
  const BG_DEFAULT = require('@/Groups/Pon/private/media/images/bg-pon-x4-size.png');
  //--------------------------------
  const isLoading = computed(() => store.state.Pon.isLoading);
  const data = computed(() => store.state.Pon.ponData);
  //--------------------------------
  // Выбор фонового изображения
  const backgroundImage = computed(() =>
    hasLegendAccess.value ? BG_LEGEND : BG_DEFAULT
  );
  //--------------------------------
  // Отслеживание оплаты
  watch(
    hasPaidAccount,
    async (newValue) => {
      if (newValue) {
        store.dispatch('Pon/fetchPonData');
      }
    },
    { immediate: true }
  );
</script>


<style lang="scss" scoped>
  @import "styles";
</style>